/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Ilya Baranchikov
 * @version 1.29.0
 * @since 1.0.0
 */

import { LocationChangeAction } from 'connected-react-router';

import { createAction } from '../app/createAction';
import {
    MODAL_CLOSE,
    MODAL_CLOSE_ALL,
    MODAL_OPEN,
    MODAL_RENDER,
    MODAL_SET_PARAMS,
    MODAL_SET_STATUS,
} from './modalConstants';
import {
    IModalOpenPayload,
    IModalRenderPayload,
    IModalSetParamsPayload,
    IModalSetStatusPayload,
    TModalCloseAction,
    TModalCloseAllAction,
    TModalOpenAction,
    TModalRenderAction,
    TModalSetParamsAction,
    TModalSetStatusAction,
} from './types/modalActionTypes';

export const modalOpen = (payload: IModalOpenPayload): TModalOpenAction => createAction(MODAL_OPEN, payload);

export const modalClose = (payload: string): TModalCloseAction => createAction(MODAL_CLOSE, payload);

export const modalCloseAll = (): TModalCloseAllAction => createAction(MODAL_CLOSE_ALL);

export const modalRender = (payload: IModalRenderPayload): TModalRenderAction => createAction(MODAL_RENDER, payload);

export const modalSetStatusAction = (payload: IModalSetStatusPayload): TModalSetStatusAction =>
    createAction(MODAL_SET_STATUS, payload);

export const modalSetParamsAction = (payload: IModalSetParamsPayload): TModalSetParamsAction =>
    createAction(MODAL_SET_PARAMS, payload);

export type TModalActions =
    | TModalCloseAction
    | TModalCloseAllAction
    | TModalOpenAction
    | TModalRenderAction
    | TModalSetStatusAction
    | TModalSetParamsAction
    | LocationChangeAction;
